<template>
  <div class="image_modal_container">
    <img class="close_button" src="/static/icons/close_white.svg" @click="handleClose">
    <img :src="imageUrl" width="100%"/>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String
    },
    onClose: {
      type: Function
    }
  },
  methods: {
    handleClose () {
      if (this.onClose) {
        this.onClose()
      }
    }
  }
}
</script>

<style scoped>
.image_modal_container {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: var(--zIndex-dim);
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.image_modal_container > .close_button {
    position: fixed;
    top: 16px;
    right: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/ai/AiImageModal.vue